/**
 * Validates document format by type (DNI / CUIT / CUIL / CDI).
 *
 * @param {string} documentType
 * @param {string} document
 * @returns {boolean}
 */
export default function documentTypeFormats(documentType, document) {
    const isnum = /^\d+$/.test(document);
    if (documentType === "DNI") {
        if (document.length < 6 || document.length > 8 || !isnum) {
            return false;
        }
    }
    if (documentType === "CUIT" || documentType === "CUIL" || documentType === "CDI") {
        if (document.length !== 11 || !isnum) {
            return false;
        }
    }
    return true;
}
